module.exports = __webpack_public_path__ + "static/assets/175b4656e28f6827b1972260c13c1ceb.png";